<template>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <div class="modal-card" style="height: 500px;">
            <header class="modal-card-head has-background-white">
                <h3 class="modal-card-title has-text-centered">
                    Gestión de usuarios
                </h3>
                <button
                    class="delete"
                    aria-label="Cerrar Modal"
                    @click="$emit('close')"
                />
            </header>
            <section class="modal-card-body">
                <div class="px-6">
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div class="column is-12-mobile">
                            <p
                                class="is-size-5 has-text-centered has-text-weight-light"
                            >
                                ¿Qué acción deseas realizar?
                            </p>
                            <div v-if="loading">
                                <br />
                                <p
                                    class="is-size-4 has-text-centered has-text-weight-bold is-danger"
                                >
                                    Espere un momento...
                                </p>
                            </div>
                        </div>
                        <div class="horizontal-separator my-2"></div>
                        <div class="column is-12-mobile is-6-desktop">
                            <b-field
                                label="Indica el RUT de la empresa a modificar"
                            >
                                <b-autocomplete
                                    v-model="company_rut"
                                    placeholder="Ejemplo: 55555555-5"
                                    open-on-focus
                                    :data="filteredCompanies"
                                    :custom-formatter="getCompanyIndentify"
                                    @select="
                                        (option) => (selectedCompany = option)
                                    "
                                >
                                    <template #empty
                                        >No results found
                                        {{ company_rut }}</template
                                    >
                                </b-autocomplete>
                            </b-field>
                        </div>
                        <div class="column is-12-mobile is-6-desktop">
                            <b-field label="Elige una acción:">
                                <b-autocomplete
                                    v-model="action"
                                    placeholder="Eliminar usuario"
                                    open-on-focus
                                    :data="filteredActions"
                                    field="name"
                                    @select="
                                        (option) => (selectedAction = option)
                                    "
                                >
                                    <template slot-scope="props">
                                        <div class="media">
                                            <div class="media-left">
                                                <img
                                                    v-if="
                                                        props.option.icon ==
                                                            'sii'
                                                    "
                                                    style="max-width:20px"
                                                    :src="siiLogo"
                                                />
                                                <i
                                                    v-if="
                                                        props.option.icon ==
                                                            'bank'
                                                    "
                                                    class="material-icons"
                                                    >account_balance</i
                                                >
                                                <i
                                                    v-if="
                                                        props.option.icon ==
                                                            'drive'
                                                    "
                                                    class="material-icons"
                                                    >cloud_done</i
                                                >
                                            </div>
                                            <div class="media-content">
                                                {{ props.option.name }}
                                            </div>
                                        </div>
                                    </template>
                                    <template #empty
                                        >No results found {{ action }}</template
                                    >
                                </b-autocomplete>
                            </b-field>
                        </div>
                    </div>
                </div>
            </section>
            <footer
                class="modal-card-foot has-background-white is-justify-content-flex-end"
            >
                <button
                    class="button"
                    @click="$emit('close')"
                    aria-label="Cerrar Modal"
                    role="button"
                >
                    Volver
                </button>
                <button
                    class="button is-danger"
                    aria-label="Eliminar mi usuario"
                    :disabled="loading"
                    role="button"
                    v-on:click.prevent="handleSubmit(submitForm)"
                >
                    Continuar
                </button>
            </footer>
        </div>
    </ValidationObserver>
</template>

<script>
import { adminAction, getAdminAction } from "@/api/adminAction";
import { getUserCompanies } from "@/api/userCompanies";
import siiMini from "@/assets/images/sii-mini.svg";
import { consoleHandlerError, notificate } from "@/utils/message";
import { ValidationObserver } from "vee-validate";

export default {
    name: "UsersManager",
    components: {
        ValidationObserver,
    },
    data() {
        return {
            loading: false,
            company_rut: "",
            companies: [],
            action: "",
            typeActions: [],
            selectedCompany: null,
            selectedAction: null,
            siiLogo: siiMini,
        };
    },
    methods: {
        submitForm() {
            this.loading = true;
            const data = {
                company: this.selectedCompany,
                action: this.selectedAction.name,
            };
            adminAction(data)
                .then(() => {
                    this.loading = false;
                    notificate(
                        `<strong>ACCIÓN COMPLETADA CON ÉXITO</strong>
                        <br>${this.action} para la ${this.company_rut} se ha
                        completado`,
                        "is-success is-light"
                    );
                })
                .catch((error) => {
                    this.loading = false;
                    consoleHandlerError({
                        error,
                        refFields: this.$refs,
                    });
                });
        },
        getCompanyIndentify(item) {
            return `${item.rut}: ${item.name}`;
        },
        filterCompanies(option) {
            return (
                option.rut.toString().indexOf(this.company_rut.toLowerCase()) >=
                    0 ||
                option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(this.company_rut.toLowerCase()) >= 0
            );
        },
    },
    computed: {
        filteredCompanies() {
            return this.companies.filter((option) => {
                return this.filterCompanies(option);
            });
        },
        filteredActions() {
            return this.typeActions.filter((option) => {
                return (
                    option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.action.toLowerCase()) >= 0
                );
            });
        },
    },
    mounted() {
        getUserCompanies().then((request) => {
            this.companies = request.data;
        });
        getAdminAction().then((request) => {
            this.typeActions = request.data;
        });
    },
};
</script>
